export default "__VITE_ASSET__Hp7SnFvO__"